//alert框
import * as React from 'react';
import  Confirm  from '../confirm';

export default function Alert(
    content: string | React.ReactNode,      //内容
) {
    Confirm("", content, [{ name: '知道了', type: 'primary', onClick: () => { } }]);
}